
import store from '@/store';

export default [
  {
    path: '*',
    redirect: {
      path: '/'
    }
  },
  {
    name: 'start-page',
    path: '/',
    redirect: {
      name: 'home'
    }
  },
  {
    name: 'movel-triagem',
    path: '/simulador/movel-triagem',
    component: () => import('@/app/views/SubLobby'),
    meta: {
      bodyClass: 'background-color--silver'
    },
    beforeEnter: (to, from, next) => {
      if (!store.state.simulation.status || store.state.simulation.status === 'initial') {
        next({
          path: '/'
        });
      } else {
        next();
      }
    }
  },
  {
    name: 'home',
    path: '/simulador/:package?',
    component: () => import('@/app/views/Lobby'),
    meta: {
      bodyClass: 'background-color--orange'
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  {
    name: 'cobertura',
    path: '/simulador/:package/:coverage?/cobertura',
    component: () => import('@/app/views/Coverage'),
    meta: {
      bodyClass: 'background-color--white'
    }
  },
  {
    name: 'procurar',
    path: '/simulador/:package/:coverage?/cobertura/procurar',
    component: () => import('@/app/views/ProcurarMorada'),
    meta: {
      bodyClass: 'background-color--silver'
    }
  },
  {
    name: 'cobertura-contacto',
    path: '/simulador/:package/:coverage?/cobertura/contacto',
    component: () => import('@/app/views/CoberturaContacto'),
    meta: {
      bodyClass: 'background-color--silver'
    }
  },
  {
    name: 'cobertura-obrigado',
    path: '/cobertura-obrigado',
    component: () => import('@/app/views/CoberturaObrigado'),
    meta: {
      bodyClass: 'background-color--orange',
      simulation: false
    }
  },
  {
    name: 'procurar_submeter_1',
    path: '/simulador/:package/:coverage?/cobertura/submeter/semcobertura',
    component: () => import('@/app/views/SubmeterMoradaSimples'),
    meta: {
      bodyClass: 'background-color--silver'
    }
  },
  {
    name: 'procurar_submeter_2',
    path: '/simulador/:package/:coverage?/cobertura/submeter/cobertura',
    component: () => import('@/app/views/SubmeterMoradaCompleto'),
    meta: {
      bodyClass: 'background-color--silver'
    }
  },
  {
    name: 'resumo',
    path: '/simulador/:package/:coverage?/resumo',
    component: () => import('@/app/views/simulator/Summary'),
    meta: {
      bodyClass: 'background-color--white',
      simulation: true
    },
    beforeEnter: (to, from, next) => {
      const activePackageConfigFeatures = store.getters['packages/getActivePackageConfig'].features;

      if (!store.state.addresses.isValid && !store.state.simulation.external && !activePackageConfigFeatures.disableCoverageVerification) {
        next({
          name: 'cobertura',
          params: {
            next: 'resumo'
          }
        });
      } else {
        next();
      }
    }
  },
  {
    name: 'guardada',
    path: '/simulador/:package/:coverage?/guardada/resumo',
    component: () => import('@/app/views/simulator/Summary'),
    meta: {
      bodyClass: 'background-color--white',
      simulation: true
    },
    beforeEnter: (to, from, next) => {
      const activePackageConfigFeatures = store.getters['packages/getActivePackageConfig'].features;

      if (!store.state.addresses.isValid && !store.state.simulation.external && !activePackageConfigFeatures.disableCoverageVerification) {
        next({
          name: 'cobertura',
          params: {
            next: 'resumo'
          }
        });
      } else {
        next();
      }
    }
  },
  {
    name: 'obrigado',
    path: '/simulador/:package/:coverage?/:from?/obrigado',
    component: () => import('@/app/views/Obrigado'),
    meta: {
      bodyClass: 'background-color--orange',
      simulation: false
    }
  },
  {
    name: 'contactar',
    path: '/simulador/:package/:coverage?/contactar',
    component: () => import('@/app/views/endings/Lead'),
    meta: {
      bodyClass: 'background-color--silver'
    },
    beforeEnter: (to, from, next) => {
      const activePackageConfigFeatures = store.getters['packages/getActivePackageConfig'].features;

      if (!store.state.addresses.isValid && !store.state.simulation.external && !activePackageConfigFeatures.disableCoverageVerification) {
        next({
          name: 'cobertura',
          params: {
            next: 'contactar'
          }
        });
      } else {
        next();
      }
    }
  },
  {
    name: 'aderir',
    path: '/simulador/:package/:coverage?/aderir',
    component: () => import('@/app/views/endings/Enroll'),
    meta: {
      bodyClass: 'background-color--silver'
    },
    beforeEnter: (to, from, next) => {
      const activePackageConfigFeatures = store.getters['packages/getActivePackageConfig'].features;
      if (!store.state.addresses.isValid && store.state.simulation.external && !activePackageConfigFeatures.disableCoverageVerification) {
        next({
          name: 'cobertura',
          params: {
            next: 'aderir'
          }
        });
      } else {
        next();
      }
    }
  },
  {
    name: 'finalizar',
    path: '/simulador/:package/:coverage?/aderir',
    component: () => import('@/app/views/endings/Subscribe'),
    meta: {
      bodyClass: 'background-color--silver'
    }
  },
  {
    name: 'concluir',
    path: '/simulador/:package/:coverage?/aderir',
    component: () => import('@/app/views/endings/Print'),
    meta: {
      bodyClass: 'background-color--silver-faint',
      simulation: true
    }
  },
  {
    name: 'ok-sem-cobertura',
    path: '/simulador/:package/:coverage?/cobertura/submeter/semcobertura/obrigado',
    component: () => import('@/app/views/Ok'),
    meta: {
      bodyClass: 'background-color--silver'
    }
  },
  {
    name: 'ok-com-cobertura',
    path: '/simulador/:package/:coverage?/cobertura/submeter/cobertura/obrigado',
    component: () => import('@/app/views/Ok'),
    meta: {
      bodyClass: 'background-color--silver'
    }
  },
  {
    name: 'referencia',
    path: '/simulador/:package/:coverage?/aderir/obrigado',
    component: () => import('@/app/views/ReferenciaBancaria'),
    meta: {
      bodyClass: 'background-color--orange',
      simulation: false
    }
  },
  {
    name: 'sem_sucesso',
    path: '/simulador/:package/:coverage?/aderir/semsucesso',
    component: () => import('@/app/views/SemSucesso'),
    meta: {
      bodyClass: 'background-color--orange',
      simulation: false
    }
  },
  {
    name: 'sem_sucesso_parceiros',
    path: '/simulador/:package/:coverage?/aderir/semsucesso',
    component: () => import('@/app/views/SemSucessoParceiros'),
    meta: {
      bodyClass: 'background-color--orange',
      simulation: false
    }
  },
  {
    name: 'simulador',
    path: '/simulador/:package/:coverage?/s/',
    component: () => import('@/app/views/Simulator'),
    meta: {
      bodyClass: 'background-color--white',
      simulation: true,
      showTimeline: true
    },
    children: [
      {
        name: 'inicio',
        path: 'inicio',
        component: () => import('@/app/views/simulator/Inicio'),
        beforeEnter: (to, from, next) => {
          const activePackageConfigFeatures = store.getters['packages/getActivePackageConfig'].features;
          const params = to.params;

          if (!store.state.addresses.isValid && !store.state.simulation.external && !activePackageConfigFeatures.disableCoverageVerification) {
            next({
              name: 'cobertura',
              params: {
                ...params,
                next: 'inicio'
              }
            });
          } else {
            next();
          }
        }
      },
      {
        name: 'internet',
        path: 'internet',
        component: () => import('@/app/views/simulator/Internet')
      },
      {
        name: 'tv',
        path: 'tv',
        component: () => import('@/app/views/simulator/Tv')
      },
      {
        name: 'premium',
        path: 'tv/premium',
        component: () => import('@/app/views/simulator/TvPremium'),
        beforeEnter: (to, from, next) => {
          let direction;
          const fromView = from.name;

          switch (fromView) {
            case 'telefone':
              direction = -1;
              break;
            default:
              direction = 1;
          }

          const isChan90Active = store.getters['cart/isPathActive']('tv.components.chan_90');
          const activeItemsInTv = store.getters['cart/activeItemsInNamespace']('tv').length;
          const params = to.params;

          if (!isChan90Active && activeItemsInTv) {
            next();
          } else {
            const nextStepInt = store.state.timeline.current + direction;
            const nextStep = store.state.timeline.items[nextStepInt];

            store.commit('timeline/SET_CURRENT', store.state.timeline.current + direction);
            next({
              name: nextStep.handle,
              params: {
                ...params
              }
            });
          }
        }
      },
      {
        name: 'telefone',
        path: 'telefone',
        component: () => import('@/app/views/simulator/Telefone')
      },
      {
        name: 'voz',
        path: 'voz',
        component: () => import('@/app/views/simulator/Voz')
      },
      {
        name: 'movel',
        path: 'movel',
        component: () => import('@/app/views/simulator/Plano2')
      },
      {
        name: 'movel_adicionais',
        path: 'movel_adicionais',
        component: () => import('@/app/views/simulator/Movel'),
        beforeEnter: (to, from, next) => {
          let direction;
          const fromView = from.name;

          switch (fromView) {
            case 'fatura':
              direction = -1;
              break;
            default:
              direction = 1;
          }

          const activeItemsInNamespace = store.getters['cart/activeItemsInNamespace']('movel');
          store.getters['cart/activeItemsInNamespace']('plano').map(item => activeItemsInNamespace.push(item));
          const params = to.params;

          if (activeItemsInNamespace.length) {
            next();
          } else {
            const nextStepInt = store.state.timeline.current + direction;
            const nextStep = store.state.timeline.items[nextStepInt];

            store.commit('timeline/SET_CURRENT', store.state.timeline.current + direction);
            next({
              name: nextStep.handle,
              params: {
                ...params
              }
            });
          }
        }
      },
      {
        name: 'plano',
        path: 'plano',
        component: () => import('@/app/views/simulator/Plano')
      },
      {
        name: 'fatura_movel',
        path: 'fatura_movel',
        component: () => import('@/app/views/simulator/FaturaMovel')
      },
      {
        name: 'fatura',
        path: 'fatura',
        component: () => import('@/app/views/simulator/Fatura')
      },
      {
        name: 'fatura_detalhe',
        path: 'fatura_detalhe',
        component: () => import('@/app/views/simulator/FaturaDetalhe'),
        beforeEnter: (to, from, next) => {
          let direction;
          const fromView = from.name;

          switch (fromView) {
            case 'permanencia':
              direction = -1;
              break;
            default:
              direction = 1;
          }

          const activeItemsInNamespace = store.getters['cart/activeItemsInNamespace']('fatura_detalhe');
          const params = to.params;

          if (activeItemsInNamespace.length) {
            next();
          } else {
            const nextStepInt = store.state.timeline.current + direction;
            const nextStep = store.state.timeline.items[nextStepInt];

            store.commit('timeline/SET_CURRENT', store.state.timeline.current + direction);
            next({
              name: nextStep.handle,
              params: {
                ...params
              }
            });
          }
        }
      },
      {
        name: 'numero',
        path: 'numero',
        component: () => import('@/app/views/simulator/Numero')
      },
      {
        name: 'permanencia',
        path: 'permanencia',
        component: () => import('@/app/views/simulator/Permanencia')
      }
    ]
  },
  {
    name: 'em_manutencao',
    path: '/manutencao',
    component: () => import('@/app/views/EmManutencao')
  }
];



// WEBPACK FOOTER //
// ./src/routes/index.js